<template>
  <div class="receivingAccountManagementDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.AccountNickName"
        :label="$t.receivingAccountManagement.accountNickName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.AccountName"
        :label="$t.receivingAccountManagement.accountName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.BankName"
        :label="$t.receivingAccountManagement.bankName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.AccountNumber"
        :label="$t.receivingAccountManagement.accountNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.SwiftCode"
        label="SWIFT CODE"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Address"
        :label="$t.receivingAccountManagement.address"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Remark"
        :label="$t.receivingAccountManagement.remark"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <div class="receivingAccountManagementDetail-radio">
        <div class="radio-label">
          {{ $t.receivingAccountManagement.accountCollectionType }}
        </div>
        <van-radio-group
          v-model="form.AccountCollectionType"
          direction="horizontal"
          @change="handleRadioChange"
        >
          <van-radio :name="1" @click="handleRadio">{{
            $t.receivingAccountManagement.collectionType1
          }}</van-radio>
          <van-radio :name="2" @click="handleRadio">{{
            $t.receivingAccountManagement.collectionType2
          }}</van-radio>
          <van-radio :name="3" @click="handleRadio">{{
            $t.receivingAccountManagement.collectionType3
          }}</van-radio>
          <van-radio :name="5" @click="handleRadio">{{
            $t.receivingAccountManagement.collectionType5
          }}</van-radio>
        </van-radio-group>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Radio, RadioGroup } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Radio).use(RadioGroup);

export default {
  name: "receivingAccountManagementDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      accountId: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      checkRadioFlag: false,
    };
  },
  created() {
    const { AccountId, IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      if (AccountId) {
        this.accountId = AccountId;
        this.getCollectionAccountDetail();
      }
    } else {
      this.form = {
        AccountNickName: "",
        AccountName: "",
        BankName: "",
        AccountNumber: "",
        SwiftCode: "",
        Address: "",
        Remark: "",
        AccountCollectionType: null,
      };
    }
  },
  methods: {
    handleRadioChange() {
      this.checkRadioFlag = true;
    },
    handleRadio() {
      if (!this.checkRadioFlag) {
        this.form.AccountCollectionType = null;
      }
      this.checkRadioFlag = false;
    },
    getCollectionAccountDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          AccountId: this.accountId,
        };
        this.$api.financialManagement
          .getCollectionAccountDetail(param)
          .then((res) => {
            this.form = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.financialManagement.editCollectionAccountInfo(param);
      } else {
        request = this.$api.financialManagement.addCollectionAccountInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.receivingAccountManagementDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .receivingAccountManagementDetail-radio {
    padding: 20px 20px 10px 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 20px;
      font-size: 14px;
    }
  }
}
</style>
